import { colors } from '@lmc/common/constants'
import React, { type ReactElement } from 'react'
import Avatar from '../../../dataDisplay/Avatar'
import { unstyledButton } from '../../unstyledButton'

export type AvatarLabelProps = {
  disabled?: boolean
  label: string
  labelStyle?: object
  onSelect?: () => void
  picture?: string
  pictureStyle?: object
  avatarSize?: number
  className?: string
  testId?: string
}

export default function AvatarLabel({
  disabled,
  label,
  labelStyle,
  onSelect,
  picture,
  pictureStyle,
  avatarSize,
  className,
  testId
}: AvatarLabelProps): ReactElement {
  if (!label) return <div style={styles.wrapper} />

  const avatarStyle = {
    ...styles.profilePic,
    ...(disabled && { opacity: 0.2 }),
    ...pictureStyle
  }

  const textStyle = {
    ...(!disabled && !!onSelect && { cursor: 'pointer' }),
    ...(disabled && { color: colors.darkgrey }),
    ...labelStyle
  }

  return (
    <div
      className={className}
      style={styles.wrapper}
      data-testid={testId || 'avatar-label'}
    >
      <Avatar
        // @ts-ignore
        onClick={!disabled && onSelect}
        size={avatarSize || 46}
        style={avatarStyle}
        url={picture}
        data-testid={testId ? `${testId}-image` : 'avatar-label-avatar'}
      />
      <button
        type="button"
        id="label"
        onClick={disabled ? undefined : onSelect}
        style={{ ...unstyledButton, ...textStyle }}
        data-testid={testId ? `${testId}-label` : 'avatar-label-text'}
      >
        {label}
      </button>
    </div>
  )
}

const styles = {
  label: {
    color: colors.black,
    display: 'block',
    fontWeight: 600,
    marginTop: 12,
    overflowWrap: 'anywhere'
  },
  profilePic: {
    marginRight: 12
  },
  profilePicGreyed: {
    marginRight: 12,
    opacity: 0.2
  },
  wrapper: {
    alignItems: 'center',
    display: 'flex',
    marginRight: 12
  }
}
